import React, { useEffect, useState } from "react";
import { Menu, message, Tooltip } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import AssessmentIcon from "@mui/icons-material/Assessment";
import ScoreIcon from "@mui/icons-material/Score";
import SchoolIcon from "@mui/icons-material/School";
import GroupsIcon from "@mui/icons-material/Groups";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import QuizIcon from "@mui/icons-material/Quiz";
import ModelTrainingIcon from "@mui/icons-material/ModelTraining";
import SettingsSuggestIcon from "@mui/icons-material/SettingsSuggest";
import FeedbackIcon from "@mui/icons-material/Feedback";
import EventNoteIcon from "@mui/icons-material/EventNote";

import "./Sider.css";

function getItem(label, key, icon, children, type) {
  return {
    key,
    icon,
    children,
    label,
    type,
  };
}

const items = [
  getItem("Manage Users", "sub1", <GroupAddIcon />),
  getItem("Manage Courses", "sub2", <SchoolIcon />),
  getItem("Manage Trainings", "sub3", <ModelTrainingIcon />),
  getItem("Manage Teams", "sub5", <GroupsIcon />),
  getItem("Configure Assessment", "sub6", <AssessmentIcon />),
  getItem("Reports", "sub4", <ScoreIcon />, "", "coursesactivityreports"),
  getItem(
    "Assign Course",
    "sub7",
    <SettingsSuggestIcon />,
    "",
    "courses/mapping"
  ),
  getItem("Assign Trainings", "sub9", <QuizIcon />, "", "trainings/mapping"),
  getItem(
    "Email Configurations",
    "sub8",
    <QuizIcon />,
    ""
    // "trainings/mapping"
  ),
  getItem("Feedback Forms", "sub10", <FeedbackIcon />, "", "feedbackforms"),
  getItem("Feedback Reports", "sub11", <FeedbackIcon />, "", "feedbackreports"),
  getItem(
    <Tooltip title="Manage career development courses, dashboards, and reports">
      Career Development Program
    </Tooltip>,
    "sub14",
    <SchoolIcon style={{ color: "#ff9900ff" }} />,
    [
      getItem(
        <Tooltip title="Career Development Dashboard">
          Career Development Dashboard
        </Tooltip>,
        "careerdevelopmentDashboard"
      ),
      getItem(
        <Tooltip title="Create Career Development Courses">
          Career Development Courses
        </Tooltip>,
        "create-careerdevelopmentcourses"
      ),
      getItem(
        <Tooltip title="Career Development Report">
          Career Development Report
        </Tooltip>,
        "careerdevelopmentcoursesreport"
      ),
    ],
    "careerdevelopmentcourses"
  ),

  getItem("Manage Events", "sub12", <EventNoteIcon />, [
    getItem("Create Events", "create-events"),
    getItem("Event User Response Report", "eventuserresponsereport"),
    // getItem("Attendance", "attendance"),
    // getItem("Learners Feedback", "learners-feedback"),
  ]),
];

const rootSubmenuKeys = [
  "sub1",
  "sub2",
  "sub3",
  "sub4",
  "sub5",
  "sub6",
  "sub7",
  "sub8",
  "sub9",
  "sub10",
  "sub11",
  "sub12",
  "sub14",
  "sub15",
];

const Courses = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const storedOpenKeys = localStorage.getItem("selectedMenu");
  const storedSelectedKey = localStorage.getItem("selectedKey");

  const [openKeys, setOpenKeys] = useState(
    storedOpenKeys ? [storedOpenKeys] : ["sub1"]
  );
  const [selectedKeys, setSelectedKeys] = useState(
    storedSelectedKey ? [storedSelectedKey] : ["sub1"]
  );
  console.log(selectedKeys, "selectedkeys");

  const onOpenChange = (keys) => {
    const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);
    if (latestOpenKey && rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
      setOpenKeys(keys);
    } else {
      setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
    }
  };

  useEffect(() => {
    const path = location.pathname;

    if (path === "" || path === "/") {
      setOpenKeys(["sub1"]);
      setSelectedKeys(["sub1"]);
      localStorage.setItem("selectedMenu", "sub1");
      localStorage.setItem("selectedKey", "sub1");
    } else {
      const selectedMenuItem = items.find(
        (i) =>
          typeof i.label === "string" &&
          i.label.toLowerCase() === path.split("/")[1]
      );
      console.log(selectedMenuItem, "selectedMenuItem");
      if (selectedMenuItem !== undefined) {
        setOpenKeys([selectedMenuItem.key]);
        setSelectedKeys([selectedMenuItem.key]);
        localStorage.setItem("selectedMenu", selectedMenuItem.key);
        localStorage.setItem("selectedKey", selectedMenuItem.key);
      } else {
        setOpenKeys([]);
        localStorage.setItem("selectedMenu", []);
        // localStorage.setItem('selectedKey', []);
      }
    }
  }, [location.pathname]);

  const handleChange = (e) => {
    const key = e.key;

    setSelectedKeys([key]);

    localStorage.setItem("selectedKey", key);

    // 🟣 Handle sub-items under Manage Events

    switch (key) {
      case "create-events":
        navigate("/create-events");

        return;

      case "eventuserresponsereport":
        navigate("/eventuserresponsereport");
        return;

      case "careerdevelopmentDashboard":
        navigate("/careerdevelopmentDashboard");
        return;

      case "create-careerdevelopmentcourses":
        navigate("/create-careerdevelopmentcourses");
        return;

      case "careerdevelopmentcoursesreport":
        navigate("/careerdevelopmentcoursesreport");
        return;

      case "upcoming-events":
      case "attendance":
      case "learners-feedback":
        return;

      default:
        break;
    }

    let foundMenu = items.find((i) => i.key === e.key);
    if (foundMenu) {
      localStorage.setItem("selectedMenu", foundMenu.key);
      localStorage.setItem("selectedKey", foundMenu.key);
      setSelectedKeys([foundMenu.key]);

      let route = foundMenu.label.toLowerCase().trim();
      let trimmedRoute = route.replace(/\s/g, "");
      if (foundMenu.key === "sub4" || foundMenu.key === "sub11") {
        navigate(`/${foundMenu.type}`);
      } else {
        navigate(`/${trimmedRoute}`);
      }
    }
  };

  return (
    <div className="Sider-main">
      <Menu
        mode="inline"
        openKeys={openKeys}
        selectedKeys={selectedKeys}
        onOpenChange={onOpenChange}
        onClick={handleChange}
        style={{
          marginTop: 70,
        }}
        items={items}
      />
    </div>
  );
};

export default Courses;
